<i18n lang='yml' src='../i18n/BookingConfirmation.yml'></i18n>
<template>
  <div v-if="booking">
    <div class="heading-block mb-0 d-flex">
      <h4>
        {{$t('book_exam')}}
      </h4>
    </div>
    <stepper v-on="$listeners" :admin='admin' activeStep="confirmation" :includeAccommodation="booking.booking_accommodations && booking.booking_accommodations.length > 0"/>
    <div class='row border-bottom'>
      <div class="col-sm-12 mb-4">
        <div class="col-sm-12 col-md-12 col-lg-10 col-xl-10">

          <ul class="booking-details-list">
            <h5 class="heading-page mt-0">
              {{$t('selected_exam_booking')}} 
            </h5>
            <li class="row">
              <span class="status-bold col-xs-12 col-md-5">
                {{$t('challenger_name')}}
              </span>
              <span class="col-xs-12 col-md-6">
                {{booking.user_identity.full_name}}
              </span>
            </li>
            <li class="row">
              <span class="status-bold col-xs-12 col-md-5">
                {{$t('sto_id')}}
              </span>
              <span v-if="booking.user_identity.external_identifiers" class="col-xs-12 col-md-6">
                {{booking.user_identity.external_identifiers.sto_id}}
              </span>
            </li>
            <li class="row">
              <span class="status-bold col-xs-12 col-md-5">
                {{$t('exam')}}
              </span>
              <span class="col-xs-12 col-md-6">
                {{booking.training_program.full_name}} - {{booking.exam_type.name[this.locale]}}
              </span>
            </li>

            <hr/>
      
            <li v-if="booking.booking_accommodations.length > 0">
              <h6 class="heading-page">
                {{$t('accommodation_requests')}}
              </h6>
              <ul>
                <li v-for="accommodation in booking.booking_accommodations" :key="accommodation.id">
                  {{$t(`accommodations.${accommodation.accommodation_type}`)}}
                </li>
              </ul>
              <span class="d-flex mt-1">
                {{$t('accommodation_guiding_text')}} 
               </span>
              <hr/>
            </li>
    
            <h6 class="heading-page  mt-0">
              {{$t('session_details')}} 
            </h6>   
            <template v-for="sitting, index in booking.sittings" :key="sitting.id">
              <li class="row">
                <h6  class="col-4">
                  {{`${$t('session')} ${index+1}`}}
                </h6>
              </li>
              <li class="row">
                <span class="status-bold col-5">
                  {{$t('scheduled_date')}}
                </span>
                <span class="col-6">
                  {{formatDate(sitting.date)}}
                </span>
              </li>
              <li class="row">
                <span class="status-bold col-5">
                  {{$t('scheduled_time')}}
                </span>
                <span class="col-6">
                  {{formatTime(sitting.start_time)}} - {{formatTime(sitting.end_time) }}
                </span>
              </li>
              <li class="row">
                <span class="status-bold col-5">
                  {{$t('location')}}
                </span>
                <span class="col-6">
                  {{sitting.sub_location.name[locale]}}
                </span>
              </li>
              <li class="row">
                <span class="status-bold col-5">
                  {{$t('address')}}
                </span>
                <span class="col-6">
                  {{sitting.sub_location.address}}
                </span>
              </li>
              <li class="row">
                <span class="status-bold col-5">
                  {{$t('phone_number')}}
                </span>
                <span class="col-6">
                  {{sitting.sub_location.phone_number}}
                </span>
              </li>
              <li class="row">
                <span class="status-bold col-5">
                  {{$t('email')}}
                </span>
                <span class="col-6 mb-2">
                  {{sitting.sub_location.email}}
                </span>
              </li>
            </template>
            <hr/>
            <h6 class="margin-top heading-page">
              {{$t('exam_resources')}} 
            </h6>  

            <div class="alert alert-info help-block">
              <font-awesome-icon :icon="['fa', 'info-circle']" />
              <span class="pl-2" v-html="$t('resource_text', { resourceLink })"></span>
            </div>
          </ul>

          <a class='btn btn-sm btn-success' :href="base_path">
            {{ $t('bookings_return') }}
          </a>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Stepper from './Stepper.vue'
import {formatDate, formatTime} from '../../../shared/typescripts/dates.ts'
export default {
  props: ['locale', 'base_path', 'admin', 'booking_data', 'english_resources_link', 'french_resources_link', 'time_format_en', 'time_format_fr'],
  components: {
    'stepper': Stepper
  },
  data() {
    return {
      booking: null,
      user_details: {},
      paymentAmount: 0
    }
  },
  mounted() {
    try {
      this.booking = JSON.parse(this.booking_data)
      this.paymentAmount = window.location.search.substring(1).split("&").find((param) => {return param == 'payment_amount'}).split("=")[1]
    }
    catch {
      console.log("Error loading booking")
    }
  },
  computed: {
    resourceLink() {
      return this.locale === 'en' ? this.english_resources_link : this.french_resources_link;
    }
  },
  methods: {
    formatDate(dateString) {
      return formatDate(dateString)
    },
    formatTime: function (date) {
      let format = this.locale == 'en' ? this.time_format_en : this.time_format_fr
      return formatTime(date, format)
    },
    nextStep() {
      this.$emit('nextStep');
    }
  }
}
</script>
